var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFooterInstagram(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 31.1 31.1",
    style: {
      enableBackground: "new 0 0 31.1 31.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke:#FFFFFF;stroke-width:0.7;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M9.3,0.6h13.2c4.5,0,8.2,3.7,8.2,8.2v13.3c0,4.5-3.7,8.2-8.2,8.2H9.3c-4.5,0-8.2-3.7-8.2-8.2V8.8 C1.1,4.3,4.8,0.6,9.3,0.6z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 15.9,
    cy: 16.4,
    r: 7.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 23.9,
    cy: 8.2,
    r: 1.7
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterInstagram);
export default __webpack_public_path__ + "static/media/footer-instagram.d571ac31137c21ab2ad2518849914f8d.svg";
export { ForwardRef as ReactComponent };